export const DELIVERY_DRAWER_URL_FRAGMENT_ID = 'delivery-and-returns-info';
export const REVIEWS_DRAWER_URL_FRAGMENT_ID = 'reviews-drawer';
export const REVIEWS_URL_FRAGMENT_ID = 'reviews';

export const getReviewsDrawerURLFragment = (reviewId?: number | null) => {
  return `${REVIEWS_DRAWER_URL_FRAGMENT_ID}${reviewId ? `-${reviewId}` : ''}`;
};
